import { jwtDecrypt } from "../../services/jwtHelper";
import { tokenAlive } from "../../services/jwtHelper";
import axios from "axios";

const axioCred = axios.create({
  withCredentials: true,
});

const state = () => ({
  authData: {
    token: "",
    tokenExp: "",
    userId: "",
    userName: "",
    roles: "",
  },
  loginStatus: "",
});

const getters = {
  getLoginStatus(state: any) {
    return state.loginStatus;
  },
  getAuthData(state: any) {
    return state.authData;
  },
  isTokenActive(state: any) {
    if (!state.authData.tokenExp) {
      return false;
    }
    return tokenAlive(state.authData.tokenExp);
  },
};

const actions = {
  async login({ commit }: { commit: any }, payload: any) {
    const response = await axioCred
      .post("https://www.biletdv.ru/customer/IBEServices/Authenticate", {
        username: payload.username,
        password: payload.password,
      })
      .catch((err) => {
        console.log(err);
      });
    if (response && response.data) {
      if (
        response.data.roles.includes("Partner") ||
        response.data.roles.includes("Subagent") ||
        response.data.roles.includes("TourOpAgent")
      ) {
        window.location.replace("http://avia.biletdv.ru");
      } else {
        commit("saveTokenData", response.data);
        commit("setLoginStatus", "success");
        const userData = await axioCred.get(
          "https://www.biletdv.ru/customer/IBEServices/GetBonusesInfo"
        );
        const bonusInfo = userData.data;
        sessionStorage.setItem("userInfo", JSON.stringify(bonusInfo));
      }
    } else {
      commit("setLoginStatus", "failed");
    }
  },
  logout({ commit }: { commit: any }) {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("userInfo");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("roles");
    commit("setLoginStatus", "");
    commit("removeTokenData");
  },
};

const mutations = {
  saveTokenData(state: any, data: any) {
    sessionStorage.setItem(
      "access_token",
      JSON.stringify(data.EncryptedAuthTicket)
    );
    sessionStorage.setItem("userName", JSON.stringify(data.userName));
    sessionStorage.setItem("roles", JSON.stringify(data.roles));
    const jwtDecodedValue = jwtDecrypt(data.EncryptedAuthTicket);
    const newTokenData = {
      token: data.EncryptedAuthTicket,
      tokenExp: jwtDecodedValue.exp,
      userId: jwtDecodedValue.unique_name,
      userName: data.userName,
      roles: data.role,
    };
    state.authData = newTokenData;
  },
  setLoginStatus(state: any, value: any) {
    state.loginStatus = value;
  },
  removeTokenData(state: any) {
    state.authData = {
      token: "",
      tokenExp: "",
      userId: "",
      userName: "",
      roles: "",
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
